import React from "react";

function Error({ message }) {
  return (
    <div className="flex justify-center mt-4">
      <p className="bg-error rounded-md text-white text-base px-4 py-2 text-center w-auto">{message}</p>
    </div>
  );
}

export default Error;
